import React from 'react';
import { connect } from 'react-redux';
import classes from './Logo.module.scss';
import * as actions from 'store/actions/index';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";

import { Link } from 'react-router-dom';

const logo = (props) => (
    <div className={['Logo', classes.Logo].join(' ')} style={{ height: props.height }}>
        <Link to={"/home"}>
            <img src={props.logo} alt={props.alt} onClick={() => props.onSetViewMode(CustomTypes.VIEW_GRID)} />
        </Link>
    </div>
);

const mapStateToProps = (state) => {
    return {
        viewmode: state.ui.clipListViewMode,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSetViewMode: (viewMode) => dispatch(actions.setClipListViewMode(viewMode)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(logo);
